import styled from 'styled-components';
import { H3 } from '@components/styles/Typography';

const StaticPagesTextContainer = ({ title, children }) => (
    <StaticPageTextContainer>
        <H3>{title}</H3>
        {children}
    </StaticPageTextContainer>
);

const StaticPageTextContainer = styled.div`
    h3 {
        margin: 20px 0;
    }

    td {
        padding: 4px;
    }
`;

export default StaticPagesTextContainer;
